import React, {Component} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import moment from "moment";
import {Button, Input} from "reactstrap";
import {isValidSGKAppointment} from "../../common/componentValidation";
import Alert from "react-s-alert";
import ReactLoading from "react-loading";
import AppointmentCard from "./AppointmentCard";

class SgkAppointmentModal extends Component {

	constructor(props) {
		super(props);
		this.state ={
		    loading:false,
		    loadingMinute:false,
			appointmentHourList:[],
			sgkAppointment:{
				appointmentTime:null
			}
		};
		this.onChangeDate = this.onChangeDate.bind(this);
		this.onChange 	  = this.onChange.bind(this);
		this.confirm 	  = this.confirm.bind(this);
		this.clearDate 	  = this.clearDate.bind(this);
		this.cancelAppointmentClicked 	  = this.cancelAppointmentClicked.bind(this);
		this.showCancelAppointmentButton 	  = this.showCancelAppointmentButton.bind(this);
	}

	componentDidMount () {
		let self = this;
		let params = {
			url: `/sgkappointment/findFirst`,
			method: "post",
            data:{
				customerId: this.props.customerId,
				month: this.props.appointmentMonth
			}
		};
		self.setState({loading:true});
		request(params)
		.then(function (response) {
			let {sgkAppointment,appointmentHours} = response.data;
			let appointmentHourList={};
			for(let i=0;i<appointmentHours.length;i++){
				if(moment(appointmentHours[i].appointmentTime).isAfter(moment().add(9,'hours'))){
					let date   = moment(appointmentHours[i].appointmentTime).format('YYYY-MM-DD');
					let hour   = moment(appointmentHours[i].appointmentTime).format('HH');
					let minute = moment(appointmentHours[i].appointmentTime).format('mm');
					if(!appointmentHourList[date]){
						appointmentHourList[date] = {};
					}
					if(!appointmentHourList[date][hour]){
						appointmentHourList[date][hour]= {};
					}
					if(!appointmentHourList[date][hour][minute]){
						appointmentHourList[date][hour][minute]={};
					}
					appointmentHourList[date][hour][minute]["count"] = appointmentHours[i].count;
					appointmentHourList[date][hour][minute]["targetCount"] = appointmentHours[i].targetCount;
				}
			}
			if(!sgkAppointment){
				sgkAppointment = {
					month: self.props.appointmentMonth,
					note:"",
					phone:"",
					email:""
				}
			}
			self.setState({sgkAppointment,loading:false,appointmentHourList});
		}).catch(function (error) {
			showAxiosError(error);
			self.props.toggle(false);
            self.setState({loading:false});
		});
	}

	onChangeDate(momentObj, name) {
		let sgkAppointment = deepCopyObject(this.state.sgkAppointment);
		if (!(typeof momentObj === "string")) {
			if (name === "date") {
				let date = momentObj.format("YYYY-MM-DD");
				let time = moment(sgkAppointment.appointmentTime).format("HH:mm:ss");
				sgkAppointment.appointmentTime = moment(date + "T" + time).format("YYYY-MM-DDTHH:mm:ss");
				this.setState({sgkAppointment});
			} else if (name === "time") {
				let time = momentObj.format("HH:mm:ss");
				let date = moment(sgkAppointment.appointmentTime).format("YYYY-MM-DD");
				sgkAppointment.appointmentTime = moment(date + "T" + time).format("YYYY-MM-DDTHH:mm:ss");
				this.setState({sgkAppointment});
			} else {

			}
		} else {

		}
	}

	onChange(e) {
		let{name,value}=e.target;
		let {sgkAppointment} = this.state;
		sgkAppointment[name] = value;
		this.setState({sgkAppointment});
	}

	clearDate(){
		let {sgkAppointment} = this.state;
		sgkAppointment['appointmentTime']=null;
		this.setState({sgkAppointment});
	}

	cancelAppointmentClicked() {
		let sgkAppointment = this.state.sgkAppointment;

		let params = {
			url: "/sgkappointment/cancelAppointment",
			method: "post",
			data: {
				sgkAppointmentId: sgkAppointment.recordId,
				sgkAppointmentTime: sgkAppointment.appointmentTime
			}
		}

		request(params).then((response) => {
			this.props.cancelAppointment();
			this.props.toggle(false)
			Alert.success("Randevu başarıyla iptal edildi.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}).catch((exception) => {
			Alert.error("Silme işlemi gerçekleşmedi!!!", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 2000
			});
		})
	}

	showCancelAppointmentButton() {
		if (this.state.sgkAppointment && this.state.sgkAppointment.appointmentTime) {
			const today = new Date();
			const appointmentTime = new Date(this.state.sgkAppointment.appointmentTime);
			return today < appointmentTime;
		} else {
			return false;
		}
	}

	confirm(date,hour,minute){
		let sgkAppointment = deepCopyObject(this.state.sgkAppointment);
		let self = this;
		let result = isValidSGKAppointment(sgkAppointment);
		let valid = result.valid;
		if (valid) {
			sgkAppointment.appointmentTime = date + "T" + hour + ":"+minute+":00";
			let params = {
				url: `/sgkappointment/save`,
				method: 'post',
				data: sgkAppointment
			};

			self.setState({confirmBtnDisabled:true,loadingMinute:true});
			request(params)
			.then(function (response) {
				self.setState({sgkAppointment});
				self.props.toggle(false,response.data);
			}).catch(function (error) {
				showAxiosError(error);
			}).then(function () {
				self.setState({confirmBtnDisabled:false,loadingMinute:false});
			});
		}else{
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 8000
			});
		}
	}

	render() {
		return (
			<DefaultModal disabled={this.state.confirmBtnDisabled}
						  isOpen={this.props.modal}
                          size="xl"
						  title={this.props.title || ""}
						  confirmBtnText=""
						  cancelBtnText={this.props.mandatoryAppointment ? "" : "Kapat"}
						  onConfirm={this.confirm}
						  onCancel={this.props.mandatoryAppointment ? null : ()=>this.props.toggle(false)}
			>
				{this.state.loading &&
				<ReactLoading type="spinningBubbles" style={{width:"90px", height: "90px", margin: "20px auto 0 auto", fill: "#888"}}/>
				}
				{!this.state.loading &&
				<div className="col-sm-12" style={{position: "unset", margin: 0, paddingTop: "4px", paddingBottom: "8px"}}>
					<div className="row">
						<div className="col-sm-6">
							<label className="col-sm-6 col-lg-5 col-form-label">Telefon Numarası *</label>
							<div className="col-sm-12 col-lg-12">
								<div className="form-group">
									<Input type="text"
										   name="phone"
										   disabled={(this.state.sgkAppointment && this.state.sgkAppointment.appointmentTime)}
										   autoComplete={"false"}
										   placeholder={"xxxxxxxxx"}
										   value={this.state.sgkAppointment.phone}
										   onChange={(e) => this.onChange(e)}/>
								</div>
							</div>
						</div>
						<div className="col-sm-6">
							<label className="col-sm-6 col-lg-5 col-form-label">e-Posta *</label>
							<div className="col-sm-12 col-lg-12">
								<div className="form-group">
									<Input type="text"
										   name="email"
										   disabled={(this.state.sgkAppointment && this.state.sgkAppointment.appointmentTime)}
										   autoComplete={"false"}
										   placeholder={"birisi@eposta.com"}
										   value={this.state.sgkAppointment.email}
										   onChange={(e) => this.onChange(e)}/>
								</div>
							</div>
						</div>

						<div className="col-sm-12">
							<div className="col-sm-12 col-lg-12">
								<div className="form-group">
									<Input type="text"
										   name="note"
										   disabled={(this.state.sgkAppointment && this.state.sgkAppointment.appointmentTime)}
										   autoComplete={"false"}
										   placeholder="Açıklama"
										   value={this.state.sgkAppointment.note}
										   maxLength={300}
										   onChange={(e) => this.onChange(e)}/>
								</div>
							</div>
						</div>

						{(this.state.sgkAppointment && this.state.sgkAppointment.appointmentTime) &&
							<div className="col-sm-12" style={{textAlign: 'center', paddingTop:'16px'}}>
								<div className="lead" style={{fontSize: '0.97rem',color:'#323639'}}>
									Randevunuz alınmıştır, {moment(this.state.sgkAppointment.appointmentTime).format("DD-MM-YYYY")} tarihinde {moment(this.state.sgkAppointment.appointmentTime).format("HH:mm")} - {moment(this.state.sgkAppointment.appointmentTime).add(30,'minutes').format("HH:mm")} saatleri arası<br/>
									{this.state.sgkAppointment.phone} telefon numarasından size dönüş yapılacaktır.<br/>
									Randevu değişikliği için <a onClick={()=>this.clearDate()}>
										<p style={{color: '#f96332', cursor: 'pointer', textDecoration: 'underline'}}>tıklayınız.</p>
									</a>
								</div>
							</div>
						}
						{!(this.state.sgkAppointment && this.state.sgkAppointment.appointmentTime) &&
						<AppointmentCard
							loading={this.state.loadingMinute}
							handleDate={(date,hour,minute)=>this.confirm(date,hour,minute)}
							appointmentHourList={this.state.appointmentHourList}
						/>
						}
						{this.showCancelAppointmentButton() &&
							<Button onClick={this.cancelAppointmentClicked} color="secondary">
								Randevu İptali
							</Button>

						}
					</div>
				</div>
				}
			</DefaultModal>
		)
	}
}

export default SgkAppointmentModal;